<form
  class="flex w-full flex-col gap-4 px-8 py-8 sm:px-8 sm:py-9"
  #addTransactionForm="ngForm"
  (ngSubmit)="addTransactionFormSubmit(addTransactionForm)"
  autocomplete="off"
  data-testid="add-transaction-form"
>
  <header class="flex flex-col gap-1">
    <h3 class="text-base font-bold text-text-title">Log a transaction</h3>
    <p class="text-sm text-text-secondary">Record a new expense or income in this budget.</p>
  </header>

  <app-ui-field label="Date" inputId="add-transaction-date">
    <app-ui-date-picker
      inputId="add-transaction-date"
      name="date"
      [(ngModel)]="transaction.date"
      required
    />
  </app-ui-field>

  <app-ui-radio-group
    legend="Transaction type"
    name="type"
    [(ngModel)]="transaction.type"
    [ngModelOptions]="{ standalone: true }"
    [options]="[
      { value: 'EXPENSE', label: 'Spent' },
      { value: 'INCOME', label: 'Received' },
    ]"
    required
  />

  <app-ui-field label="Transaction Amount" inputId="add-transaction-amount">
    <app-ui-currency-input
      inputId="add-transaction-amount"
      testId="add-transaction-amount"
      name="amount"
      min="0.01"
      required
      [(ngModel)]="transaction.amount"
    />
  </app-ui-field>

  <app-ui-field label="Merchant Name" inputId="add-transaction-merchant">
    <input
      id="add-transaction-merchant"
      data-testid="add-transaction-merchant"
      appUiInput
      type="text"
      [(ngModel)]="transaction.merchant"
      name="merchant"
      required
    />
  </app-ui-field>

  <app-label-typeahead [(selectedLabelIds)]="transaction.labelIds" />

  <app-ui-field label="Description" inputId="add-transaction-description">
    <textarea
      id="add-transaction-description"
      data-testid="add-transaction-description"
      appUiInput
      placeholder="More information about this transaction..."
      [(ngModel)]="transaction.description"
      name="description"
    ></textarea>
  </app-ui-field>

  <button
    appUiButton
    appearance="solid"
    tone="primary"
    type="submit"
    data-testid="add-transaction-submit"
    class="mt-2 self-stretch"
    [disabled]="!addTransactionForm.form.valid || loading()"
  >
    Add Transaction
  </button>
</form>
